// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { ContextStore } from 'bernie-core';
import { LocalizedText, withLocalization } from 'bernie-l10n';

// ui
import { UitkCardPlaceholder } from 'uitk-react-cards';
import { UitkCarousel } from 'uitk-react-carousel';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';

// mobx
import { Product } from 'models';
import { ProductStore } from 'stores';

// shared-ui
import { ILocalization, LocalizedComponentProps } from '@shared-ui/localization-context';

// components
import { ProductCard } from '../products/product-card';

interface ToolsProps extends LocalizedComponentProps {
  context?: ContextStore;
  l10n?: ILocalization;
  products?: ProductStore;
}

interface ToolsState {
  products: Product[];
}

@withLocalization
@inject('context', 'products')
export class Tools extends React.Component<ToolsProps, ToolsState> {
  public constructor(props) {
    super(props);

    this.state = {
      // Hard-coded show off list? Should be parameterised somewhere?
      products: this.props.products.getProducts('us-bex'),
    };
  }

  public render() {
    const { context, l10n } = this.props;

    const { products } = this.state;

    const liveProducts = products.filter((product) => product.live && product.name !== 'covid19');
    const cards = liveProducts.map((product, i) => {
      return (
        <UitkLayoutGridItem key={`product-${i}`}>
          <ProductCard locale={context.locale} key={product.name} l10n={l10n} product={product} />
        </UitkLayoutGridItem>
      );
    });

    return (
      <>
        <UitkHeading tag="h2" size={3}>
          <LocalizedText message="lp.home.tools.title" />
        </UitkHeading>
        <UitkText spacing="six">
          <UitkText inline={true} weight="bold">
            <LocalizedText message="lp.home.tools.description.join" />
          </UitkText>{' '}
          <UitkText inline={true}>
            <LocalizedText message="lp.home.tools.description.our.help" />
          </UitkText>
        </UitkText>
        <UitkSpacing padding={{ blockstart: 'six' }}>
          <UitkLayoutGrid columns={{ small: 1, medium: 2, extra_large: 3 }} space="four">
            {cards}
          </UitkLayoutGrid>
        </UitkSpacing>
      </>
    );
  }
}
